import { useState } from 'react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/TextField';
import { ApiUnavailablePanel } from '../../components/ui/ApiUnavailablePanel';

export function ProviderSearchAskPage() {
  const [q, setQ] = useState('');

  return (
    <div className="space-y-5">
      <section className="rounded-2xl border border-eorig-border bg-white p-5 shadow-eorig-card">
        <h2 className="text-sm font-semibold text-eorig-ink">Grounded search</h2>
        <p className="mt-1 text-xs text-eorig-muted">
          Packages, assets, evidence, and custody events.
        </p>
        <form
          className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end"
          onSubmit={(event) => event.preventDefault()}
        >
          <TextField
            id="provider-search-q"
            label="Query"
            placeholder="Search by package, loan, or document hash"
            value={q}
            onChange={(event) => setQ(event.target.value)}
            className="min-w-0 flex-1"
          />
          <Button type="submit" variant="navy" className="sm:mb-0">
            Search
          </Button>
        </form>
      </section>
      <ApiUnavailablePanel title="Results">
        Search is not connected yet. No sample packages or answers are shown.
      </ApiUnavailablePanel>
    </div>
  );
}
